import {Row} from '../Row';
import scenarioCreateIcon from '../../assets/images/icons/scenario/scenario-create.png';
import {Scenario} from '../ItemList/scenario';
import scenarioIcon from '../../assets/images/icons/scenario/scenario.png';
import triggerCreateIcon from '../../assets/images/icons/scenario/trigger-create.png';
import triggerIcon from '../../assets/images/icons/scenario/trigger.png';
import React, {memo, ReactNode, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFilterSelector} from '../../hooks/filter-selector';
import {
    toggleScenarioScreenAction, toggleScenarioSTPUIInputScreenAction, toggleScenarioTriggerInputScreenAction,
    toggleScenarioTriggerPopupScreenAction,
    toggleScenarioTriggerScreenAction,
} from '../../store/ui/actions';
import {ScenarioTriggerModel, STPUIEntity} from '../../store/control/state';
import {InputModel} from '../../types/control';
import {Column} from '../Column';
import {Widget} from '../Widget';
import {Button} from '../Button';

type MyButtonProps = { icon: string, title: string, onClick: () => void, children?: ReactNode };
const MyButton = memo(function MyButton({icon, title, onClick, children}: MyButtonProps) {
    return (
        <Column min={3} max={6}>
            <Widget style={{padding: 0}}>
                <Button icon={icon} title={title} onClick={onClick}>
                    {children}
                </Button>
            </Widget>
        </Column>
    );
});

export function ScenarioPage() {
    const dispatch = useDispatch();
    const scenarioList = useSelector(state => state.control.scenarioList);
    const scenarioTriggerList = useSelector(state => state.control.scenarioTriggerList);
    const scenarioTriggerControls = useFilterSelector(state => state.control.inputList, i => i.type_id === '3', []); // todo constant
    const scenarioStpUIList = useFilterSelector(state => state.control.stpUIList, (u) => u.type === 'scenario');

    const createScenario = useCallback(() => {
        dispatch(toggleScenarioScreenAction(null));
    }, [dispatch]);

    const createTrigger = useCallback(() => {
        dispatch(toggleScenarioTriggerScreenAction(null));
    }, [dispatch]);

    const openTrigger = useCallback((trigger: ScenarioTriggerModel) => {
        dispatch(toggleScenarioTriggerPopupScreenAction(trigger));
    }, [dispatch]);

    const openTriggerInput = useCallback((input: InputModel) => {
        dispatch(toggleScenarioTriggerInputScreenAction(input));
    }, [dispatch]);

    const openSTPUITrigger = useCallback((stpUIEntity: STPUIEntity) => {
        dispatch(toggleScenarioSTPUIInputScreenAction(stpUIEntity));
    }, [dispatch]);

    return (
        <>
            <Row>
                <MyButton icon={scenarioCreateIcon} title='SENARYO EKLE' onClick={createScenario}/>
                {
                    scenarioList.map(scenario => (
                        <Scenario key={`scenario_${scenario.id}`} scenario={scenario}/>
                    ))
                }
            </Row>
            <Row style={{marginTop: 119}}>
                <MyButton icon={triggerCreateIcon} title='TETİKLEYİCİ EKLE' onClick={createTrigger}/>
                {
                    scenarioTriggerList.map(trigger => (
                        <MyButton
                            key={`scenario_trigger_${trigger.id}`}
                            icon={triggerIcon} title={trigger.name}
                            onClick={() => openTrigger(trigger)}/>
                    ))
                }
                {
                    scenarioTriggerControls.map(input => (
                        <MyButton
                            key={`scenario_trigger_control_${input.id}`}
                            icon={triggerCreateIcon} title={input.name}
                            onClick={() => openTriggerInput(input)}/>
                    ))
                }
                {
                    scenarioStpUIList.map(stpUiEntity => (
                        <MyButton
                            key={`stp_ui_entity_${stpUiEntity.id}`}
                            icon={scenarioList.find(s => s.id === stpUiEntity.relational_id) != null ? scenarioIcon : triggerCreateIcon}
                            title={stpUiEntity.display_name}
                            onClick={() => openSTPUITrigger(stpUiEntity)}/>
                    ))
                }
            </Row>
        </>
    );
}
